(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricOwnerCertificationWelcomeController', Controller);

    Controller.$inject = ['$scope', '$state', 'notificationService', 'aricControls'];

    function Controller($scope, $state, notificationService, aricControls) {

        // go To First ReadyForCertification Control
        $scope.goToFirstReadyForCertificationControl = function () {
            var aricControlIdx = _.findIndex(aricControls, { ControlAssessment: { IsReadyForCertification: true } });

            if (aricControlIdx == -1) {
                aricControlIdx = _.findIndex(aricControls, { ControlAssessment: { IsCertificationInProgress: true } });
            }

            if (aricControlIdx > -1) {
                $state.go('aricCertification.user.control', { ControlID: aricControls[aricControlIdx].ControlID });
            }
            else {
                notificationService.notify("You don't have any control to certify.");
            }
        };
    }
})();